// extracted by mini-css-extract-plugin
export default {"container":"UBjulTbvjVisNiCEEfZu","outline":"H1aIOTYmM0JMEXGXnH_y","title":"HbfqQ8jyy4AYlBiaJhQ9","closeButton":"euggCrn4GERCnSZDFfDB"};